interface IProps {
    id: number,
    alias: string,
    centerId: number,
    isDonorCenter: boolean
}

const DonorAlias = (props: IProps) => {
    if (props.isDonorCenter) {
        return (
            <a href={`center/${props.centerId}/donor/${props.id}/profile/donor-data`} target='_blank'>{props.alias}</a>
        )
    }

    return (
        <>{props.alias}</>
    );
};

export default DonorAlias;